<div class="stack">
  <ng-container #entrypoint></ng-container>
</div>
